import { useNewSpaceGroupModal } from "@circle-react/components/Modals/NewSpaceGroupModal";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { communitiesPaths } from "@circle-react/helpers/routerPathHelpers";
import { useMatchRoute } from "@tanstack/react-router";

import { useHideOnboardingConfirmationModal } from "@/react/components/Modals/HideOnboardingConfirmationModal";
import { useSpotlightSearch } from "@/react/components/Modals/SpotlightSearch";
import { isCommunityAdmin } from "@/react/helpers/communityMemberHelpers";
import { useChecklistAvailable } from "@/react/hooks/useChecklistAvailable";

export const usePlatformMenu = () => {
  const { isChecklistAvailable } = useChecklistAvailable();
  const { currentCommunity, currentCommunityMember, currentCommunitySettings } =
    usePunditUserContext();

  const spaceGroupModal = useNewSpaceGroupModal();
  const toggleSpaceGroupDrawer = (position = 1) => {
    void spaceGroupModal.show({ position });
  };

  const matchRoute = useMatchRoute();
  const isOnboardingActive = Boolean(
    matchRoute({ to: communitiesPaths.onboarding() }),
  );
  const hideOnboardingConfirmationModal = useHideOnboardingConfirmationModal();
  const isAdmin = Boolean(isCommunityAdmin(currentCommunityMember));

  const shouldShowOnboarding = isChecklistAvailable;
  const spotlightSearch = useSpotlightSearch();

  const showSpotlightSearch = () => {
    void spotlightSearch.show();
  };

  const shouldShowAllEventsPage = Boolean(
    isAdmin || currentCommunitySettings?.public_events_page,
  );

  return {
    shouldShowOnboarding,
    isOnboardingActive,
    hideOnboardingConfirmationModal,
    currentCommunity,
    currentCommunitySettings,
    currentCommunityMember,
    isAdmin,
    spotlightSearch,
    toggleSpaceGroupDrawer,
    showSpotlightSearch,
    shouldShowAllEventsPage,
  };
};
